import {FormattedMessage} from "react-intl";
import styles from "./index.module.scss";

function OneButton({dismiss, titleId, contentId}) {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        <FormattedMessage id={titleId} />
      </h3>
      <p className={styles.contents}>
        <FormattedMessage id={contentId} />
      </p>

      <div className={styles.btn_box}>
        <button className={styles.check} type="button" onClick={dismiss}>
          <FormattedMessage id="ID_POPUP_BTN_CONFIRM" />
        </button>
      </div>
    </div>
  );
}

export default OneButton;
